import styles from "../../css/dist/index.module.css";

export const LoadingIcon = () => { return (<span className={`${styles["loading"]} ${styles["loading-ball"]} ${styles["loading-lg"]}`}></span>); };
